import {FiCircle,FiStar,FiHelpCircle,FiSlash} from 'react-icons/fi';
import {nextStoryPriority,storyPriorityLabel} from '../lib/storyPriority.js';
const icons={'':FiCircle,must:FiStar,maybe:FiHelpCircle,avoid:FiSlash};
const labels={'':'Mark priority',must:'Must',maybe:'Maybe',avoid:'Avoid'};

// A source transcript decision, not a status of a clip already in Assembly.
export default function SourcePriorityButton({priority='',disabled=false,onChange}){
 const Icon=icons[priority]||FiCircle,next=nextStoryPriority(priority);
 return <button type="button" className={'transcript-source-priority is-'+(priority||'unmarked')}
  data-priority={priority||'none'} disabled={disabled}
  aria-label={'Selected source words: '+(storyPriorityLabel(priority)||'No priority')+'. Click for '+(storyPriorityLabel(next)||'No priority')}
  title={'Selected words: '+(storyPriorityLabel(priority)||'No priority')+' · Next: '+(storyPriorityLabel(next)||'No priority')}
  onClick={()=>onChange(next)}><Icon aria-hidden="true"/> {labels[priority]||'Mark priority'}</button>;
}
